import type { Application } from '../types/applications'

const getCreationTime = (application: Application) => {
	const creationTime = Date.parse(application?.creationTime || '')

	return Number.isNaN(creationTime) ? 0 : creationTime
}

export const getSortedFilteredApplications = (
	applications: Application[] = [],
	filterText = ''
) => {
	const searchText = filterText.toLowerCase()

	return [...applications]
		.filter((app) => {
			const appName = app?.details?.applicationName?.toLowerCase() || ''
			const appID = app?.applicationID?.toLowerCase() || ''

			return appName.includes(searchText) || appID.includes(searchText)
		})
		.sort((a, b) => getCreationTime(b) - getCreationTime(a))
}
